<!-- hs-no-loaded-account is the only gate: it shows "no account loaded" until a session exists with
     accounts. The accountId the field catalog is keyed on comes from that session, never from the
     Accounts-panel selection — selecting another account while a session is open must not swap the
     open session's columns for a different account's. -->
<hs-no-loaded-account [content]="workbench"></hs-no-loaded-account>

<ng-template #workbench>
  <div class="workbench-host" *ngIf="isEnfusionSession; else notApplicable">
    <div
      class="wb-region comparison"
      #comparison
      [style.flexGrow]="regionGrow.comparison"
    >
      <hs-cache-load-listener
        [content]="comparisonGridContent"
        [sessionCacheStatus]="comparisonCacheStatus"
        [sessionId]="currentSessionId"
        [accountIds]="currentAccountIds"
      ></hs-cache-load-listener>
      <ng-template #comparisonGridContent>
        <hs-positions-workbench-grid
          [role]="comparisonRole"
        ></hs-positions-workbench-grid>
      </ng-template>
    </div>

    <hs-resize-handle
      [elem1]="comparison"
      [elem2]="base"
      [initialResizeHandleState]="state?.gridResizeHandleState"
      (resizeFinished)="onGridResizeFinished($event)"
    ></hs-resize-handle>

    <div class="wb-region base" #base [style.flexGrow]="regionGrow.base">
      <hs-cache-load-listener
        [content]="baseGridContent"
        [sessionCacheStatus]="baseCacheStatus"
        [sessionId]="currentSessionId"
        [accountIds]="currentAccountIds"
      ></hs-cache-load-listener>
      <ng-template #baseGridContent>
        <hs-positions-workbench-grid
          [role]="baseRole"
        ></hs-positions-workbench-grid>
      </ng-template>
    </div>

    <hs-resize-handle
      [elem1]="base"
      [elem2]="detail"
      [initialResizeHandleState]="state?.detailResizeHandleState"
      (resizeFinished)="onDetailResizeFinished($event)"
    ></hs-resize-handle>

    <div class="wb-region detail" #detail [style.flexGrow]="regionGrow.detail">
      <ul
        ngbNav
        #nav="ngbNav"
        class="nav-tabs"
        [activeId]="activeTab"
        (navChange)="onTabChange($event.nextId)"
      >
        <!-- The tooltip sits on the <li>, not the link: Bootstrap's disabled nav-link has
             `pointer-events: none`, so the link itself never sees the hover. container="body"
             because the detail region clips anything that overflows it. -->
        <li
          *ngFor="let tab of tabs"
          [ngbNavItem]="tab.key"
          [disabled]="!!tab.disabled"
          [ngbTooltip]="tab.disabledReason"
          [disableTooltip]="!tab.disabled || !tab.disabledReason"
          container="body"
        >
          <a class="position-nav-item" ngbNavLink>{{ tab.label }}</a>
          <ng-template ngbNavContent>
            <!-- Position Comparison and Position Detail are wired to the anchor row. Historical
                 Balance is disabled (SUB_PANEL_TABS) and so never renders content here. -->
            <hs-position-comparison
              *ngIf="tab.key === 'comparison'"
            ></hs-position-comparison>
            <hs-position-detail
              *ngIf="tab.key === 'detail'"
            ></hs-position-detail>
          </ng-template>
        </li>
      </ul>
      <!-- `detail-outlet` is this component's own hook for sizing the outlet and the tab pane ngb
           renders inside it: the `[ngbNavOutlet]` binding is not reflected as a DOM attribute, so
           there is nothing else stable to select on. See the height-chain note in the scss. -->
      <div [ngbNavOutlet]="nav" class="detail-outlet"></div>
    </div>
  </div>
</ng-template>

<!-- Not applicable for a CW session — Flex Positions has no data for it. A CW session never
     focuses an account for this panel (positions-2-panel.component.ts), so the Flex caches never
     get asked to load and each grid's hs-cache-load-listener would wait forever — this gate exists
     precisely so a CW session never reaches that wrapper at all. -->
<ng-template #notApplicable>
  <hs-panel-card header="Not Applicable">
    <p>Not applicable for current session — use the Positions panel.</p>
  </hs-panel-card>
</ng-template>
